import React, { useContext, useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import LayoutMain_Coral from '../LayoutMain_Coral/LayoutMain_Coral';
import AppContext from '../../../store/AppContext';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import WaterMark from "../DashboardMain_Coral/WaterMark";
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom';
import { isExpired, decodeToken } from "react-jwt";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"

const SESSION_IDEL_MINUTES = 1;

function VehicleInsights_Coral() {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const app_ctx = useContext(AppContext);
    const navigate = useNavigate();
    const [isDriveEnable, setIsDriveEnable] = useState(false)
    const [isFaultEnable, setIsFaultEnable] = useState(false)
    const [isFaultEnableSecond, setIsFaultEnableSecond] = useState(false)
    const [isChargeEnable, setIsChargeEnable] = useState(false)
    const [isRcaEnable, setIsRcaEnable] = useState(false)


    const loggedInUser = useSelector(selectLoggedInUser);
    // const log_data = (data) => {
    //    console.log(data);

    // }
    //  const handleOnIdle = (event: any) => {
    //     // SHOW YOUR MODAL HERE AND LAGOUT
    //     console.log('user is idle', event)
    //     console.log('last active', getLastActiveTime())
    //     navigate("/login");
    // }

    // const {getLastActiveTime } = useIdleTimer({
    //     timeout: 1000 * 60 * SESSION_IDEL_MINUTES,
    //     onIdle: handleOnIdle,
    //     debounce: 500,
    // })
    // window.onunload = function () {
    //     app_ctx.logout_user();
    // }
    useEffect(() => {
        //let user_data = JSON.parse(sessionStorage.user);
        // console.log("called");
        fetchData({
            url: API_URL_MAIN + "auth/logging", body: {
                page_name: "vehicleinsights"
            }
        })
    }, []);

    useEffect(() => {
        //let user_data = JSON.parse(sessionStorage.user);
        // console.log("called");
        // fetchData({
        //     url: API_URL_MAIN + "auth/logging", body: {
        //         page_name: "vehicleinsights"
        //     }
        // })
        const tokenNew = JSON.parse(sessionStorage.user);
        let decodedToken = decodeToken(tokenNew.token);
        const usernameNew = decodedToken.access_type;
        // const usernameNew = "1,2,3";
        // const usernameNew = "1,2,3,4";
        var split_str = usernameNew.split(",");
        if (split_str.indexOf("1") !== -1) {
            setIsDriveEnable(true)
        }
        if (split_str.indexOf("2") !== -1) {
            setIsFaultEnable(true)
        }
        if (split_str.indexOf("3") !== -1) {
            setIsFaultEnableSecond(true)
        }
        // if (split_str.indexOf("4") !== -1) {
        //     setIsChargeEnable(true)
        // }
        if (split_str.indexOf("9") !== -1) {
            setIsRcaEnable(true)
        }

    }, [isDriveEnable, isFaultEnable, isFaultEnableSecond, isChargeEnable, isRcaEnable]);

    const token = JSON.parse(sessionStorage.user);
    let myDecodedToken = decodeToken(token.token);
    let ev_bus = myDecodedToken.ev_bus;

    return (
        <>
            <LayoutMain_Coral>
                <div className="row">
                    <WaterMark />
                    {
                        isDriveEnable &&
                        <div className="col-md-3 " style={{}}>
                            <Link to="/Driveanalysis_Coral">
                                <div className="dashboard_card ev_card_title">
                                    <img src="../../../assets/img/DriveAnalysis.svg" />
                                    {/* <span>Fault Code Analysis Dashboard</span> */}
                                    <span>Drive Analysis</span>
                                </div>
                            </Link>
                        </div>
                    }
                    {
                        isFaultEnableSecond &&

                        <div className="col-md-3 " style={{}}>

                            <Link to="/VehicleInsights_Coral/Faultanalysis_Coral">
                                <div className="dashboard_card">
                                    <img src="../../../assets/img/FaultAnalysis.svg" />
                                    {/* <span>Fault Code Analysis Dashboard</span> */}
                                    <span>Fault Analysis</span>
                                </div>
                            </Link>
                        </div>
                    }
                    {
                        // loggedInUser.flagForHideShow === "ERC" &&
                        isFaultEnable &&
                        <div className="col-md-3 " style={{}}>
                            <Link to="/faultanalysis_coral">
                                <div className="dashboard_card ev_card_title">
                                    <img src="../../../assets/img/FaultAnalysis.svg" />
                                    {/* <span>Fault Code Analysis Dashboard</span> */}
                                    <span>Fault Analysis</span>
                                </div>
                            </Link>
                        </div>
                    }
                    {
                        // isChargeEnable &&
                        // <div className="col-md-3 " style={{}}>
                        //     <Link to="/dashboard/charginganalysis">
                        //         <div className="dashboard_card ev_card_title">
                        //             <img src="../../../assets/img/ChargingAnalysis.svg" />
                        //             {/* <span>Fault Code Analysis Dashboard</span> */}
                        //             <span>Charging Analysis</span>
                        //         </div>
                        //     </Link>
                        // </div>
                    }
                    {
                        // ev_bus === "ERC_ACE" && isRcaEnable &&
                        loggedInUser.flagForHideShow === "ERC" && isRcaEnable &&
                        <div className="col-md-3 " style={{}}>
                            <Link to="/dashboard/rca">
                                <div className="dashboard_card ev_card_title">
                                    <img src="../../../assets/img/rca_ace.png" />
                                    {/* <span>Fault Code Analysis Dashboard</span> */}
                                    <span>RCA</span>
                                </div>
                            </Link>
                        </div>
                    }
                    {/* <div className="col-md-3 " style={{}}>
                        <Link to="/dashboard/faultanalysis2">
                            <div className="dashboard_card">
                                <img src="../../../assets/img/charging-station1.png" />
                                
                                <span>Fault Analysis1</span>
                            </div>
                        </Link>
                    </div> */}

                    {/* <div className="col-md-3 " style={{}}>
                    <div className="dashboard_card">
                        <img src="../../../assets/img/fault_big.png" />
                        <span>Fault Code Analysis Dashboard</span>
                    </div>
                </div> */}
                    <div className="col-md-6">

                    </div>
                </div>
            </LayoutMain_Coral>
        </>
    );
}
export default VehicleInsights_Coral;
